import { toDate as o } from "./toDate.js";
function u(t) {
  return o(t).getHours();
}
export {
  u as default,
  u as getHours
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getHours.js
// module id = 445
// module chunks = 67